<template>
  <v-container class="mb-4 pa-5" fluid>
    <h1 class="display-1 font-weight-bold mb-5">
    News
    </h1>
    <NewsWidget mode="default"></NewsWidget>
  </v-container>
</template>

<script>

  import NewsWidget from "@/components/NewsWidget.vue"

  export default {
    name: "News",
    data() {
      return {
      }
    },
    components: {
      NewsWidget
    },
  };
</script>

<style>
</style>
